// Module
var code = "<div v-if=\"isMobile\"> <footer class=\"footer\"> <div class=\"container-footer text-center\"> <span class=\"text-muted\" style=\"font-size:50%;margin-bottom:10px\">© FRONTIER CONSULTING Co., Ltd.</span> </div> </footer> </div>";
// Exports
export default code;